import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-archive-vehicle',
  templateUrl: './archive-vehicle.component.html',
  styleUrls: ['./archive-vehicle.component.scss'],
})
export class ArchiveVehicleComponent implements OnInit {
  vehicle: any;

  constructor(
    @Optional()
    private config: DynamicDialogConfig,
    @Optional()
    private ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.vehicle = this.config?.data?.formdata || this.config?.data || {};
  }

  close(): void {
    this.ref?.close();
  }

  confirmArchive(): void {
    this.ref?.close(this.vehicle);
  }
}
